import { datadogRum } from '@datadog/browser-rum';

import type { ReportError } from './reportError.types';

export const reportError: ReportError = async (error, options) => {
  const reportable =
    options?.fingerprint === undefined
      ? error
      : Object.assign(error, { dd_fingerprint: options.fingerprint });

  datadogRum.addError(reportable, { ...options?.context, expected: options?.expected === true });
};
